export default __webpack_public_path__ + "static/media/about_bg.0694bcab.png";